import React from "react";
import { Swords, Truck } from "lucide-react";
import { useI18n } from "../lib/i18n";

export function DeliveryStatusBanner({ o }) {
  const { t } = useI18n();
  if (o.status === "shipped" || o.status === "completed") {
    const h = [...o.history].reverse().find((x) => x.status === "shipped");
    return (
      <div data-testid="order-shipped-banner" className="bg-[#35C78A]/10 border border-[#35C78A] rounded-lg p-5 mb-6 flex gap-3">
        <Truck className="text-[#35C78A] shrink-0" size={22} />
        <div>
          <div className="text-[#35C78A] font-bold">{t("order.shipped_title")}</div>
          {h && <div className="text-xs text-[#A8A8AD] mt-1">{new Date(h.at).toLocaleString()} · {h.by}</div>}
          {h?.note && <div className="text-sm text-[#F5F3ED] mt-1 whitespace-pre-wrap">{h.note}</div>}
          {h?.video_url && <a href={h.video_url} target="_blank" rel="noreferrer" data-testid="order-shipped-video-link" className="inline-block mt-2 text-sm text-[#D4AF37] hover:underline break-all">▶ {t("order.watch_video")}</a>}
        </div>
      </div>
    );
  }
  if (o.status !== "preparing" || !o.trade_ready) return null;
  const r = o.trade_ready;
  return (
    <div data-testid="order-trade-ready-banner" className="bg-[#D4AF37]/10 border border-[#D4AF37] rounded-lg p-5 mb-6 flex gap-3">
      <Swords className="text-[#D4AF37] shrink-0" size={22} />
      <div>
        <div className="text-[#D4AF37] font-bold">{t("order.trade_ready_title")}</div>
        <div className="text-xs text-[#A8A8AD] mt-1">{new Date(r.at).toLocaleString()} · {r.by}</div>
        {o.delivery?.character_name && <div className="text-sm text-[#F5F3ED] mt-1">{t("order.trade_ready_char")} <span className="font-mono">{o.delivery.character_name}</span></div>}
        {r.note && <div data-testid="order-trade-ready-note" className="text-sm text-[#F5F3ED] mt-1 whitespace-pre-wrap">{r.note}</div>}
      </div>
    </div>
  );
}
